<template>
  <div>
    <label for="uniqueConditions">Egyedi feltétel</label>
    <div v-for="condition in uniqueConditions" v-bind:key="condition.id" class="d-flex">
      <b-form-input
        :id="condition.id"
        placeholder="Sajátos feltétel leírása"
        trim
        class="col-11 mb-4"
        v-model="condition.condition"
        @input="onConditionChange(condition.id, condition.condition)"
        style="margin-left: 0px"
      ></b-form-input>
      <div
        v-if="condition.id !== '0'"
        class="col-1 d-flex align-items-center justify-content-end"
        style="padding: 0px; height: 48px;"
      >
        <font-awesome-icon icon="fa-solid fa-trash" class="cursor-pointer" @click="deleteCondition(condition.id)" />
      </div>
    </div>
    <p class="cursor-pointer" @click="addExtraCondition">
      <strong>+ Egyedi feltétel hozzáadása </strong>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    alreadySelected: { type: Array }
  },
  data() {
    return {
      uniqueConditions: [{ id: '0', condition: '' }]
    }
  },
  methods: {
    onConditionChange(id, value) {
      const newAr = this.uniqueConditions
        .map(condition => {
          if (condition.id === id) {
            return { id, condition: value }
          }
          return condition
        })
        .filter(x => x !== undefined)
      this.uniqueConditions = newAr
    },
    addExtraCondition() {
      let newItem = {
        id: (Number(this.uniqueConditions[this.uniqueConditions.length - 1].id) + 1).toString(),
        condition: ''
      }
      this.uniqueConditions.push(newItem)
    },
    deleteCondition(id) {
      const newAr = this.uniqueConditions
        .map(condition => {
          if (condition.id === id) {
            return
          }
          return condition
        })
        .filter(x => x !== undefined)
      this.uniqueConditions = newAr
    }
  },
  watch: {
    uniqueConditions: {
      handler(value) {
        this.$emit('unique-conditions', value)
      },
      deep: true
    }
  },
  mounted() {
    if (this.alreadySelected.length > 0) {
      this.uniqueConditions = this.alreadySelected
    }
  }
}
</script>

<style lang="scss" scoped></style>
